var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankOfferInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info 4",
    clipPath: "url(#clip0_10070_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.2375 3.7875C7.05 3.975 6.825 4.05 6.5625 4.05C6.3 4.05 6.075 3.975 5.8875 3.7875C5.7 3.6 5.5875 3.4125 5.5875 3.15C5.5875 2.8875 5.7 2.7 5.8875 2.5125C6.0375 2.325 6.2625 2.25 6.5625 2.25C6.825 2.25 7.05 2.325 7.2375 2.5125C7.425 2.7 7.5 2.8875 7.5 3.15C7.5 3.4125 7.425 3.6 7.2375 3.7875ZM7.275 9.375C6.9375 9.4875 6.7125 9.6 6.4875 9.675C6.3 9.75 6.075 9.7875 5.8125 9.7875C5.4375 9.7875 5.1 9.7125 4.9125 9.4875C4.6875 9.3 4.575 9.0375 4.575 8.775C4.575 8.6625 4.575 8.55 4.6125 8.4375C4.6125 8.325 4.65 8.175 4.6875 8.025L5.1 6.6C5.1375 6.45 5.175 6.3375 5.175 6.225C5.2125 6.1125 5.2125 6 5.2125 5.8875C5.2125 5.7 5.175 5.5875 5.1 5.5125C5.025 5.4375 4.875 5.4 4.65 5.4C4.5375 5.4 4.425 5.4 4.35 5.4375C4.2375 5.475 4.1625 5.5125 4.0875 5.55L4.2 5.1C4.4625 4.9875 4.725 4.9125 4.95 4.8375C5.175 4.7625 5.4 4.725 5.625 4.725C6 4.725 6.3 4.8 6.525 4.9875C6.75 5.175 6.825 5.4 6.825 5.7C6.825 5.775 6.825 5.8875 6.7875 6.0375C6.7875 6.1875 6.75 6.3375 6.7125 6.45L6.375 7.8375C6.3375 7.95 6.3 8.1 6.3 8.2125C6.2625 8.3625 6.2625 8.475 6.2625 8.55C6.2625 8.7375 6.3 8.85 6.375 8.925C6.45 9 6.6 9.0375 6.825 9.0375C6.9375 9.0375 7.05 9.0375 7.1625 9C7.275 8.9625 7.3875 8.925 7.425 8.925L7.275 9.375ZM12 6C12 9.3 9.3 12 6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6ZM6 0.75C3.1125 0.75 0.75 3.1125 0.75 6C0.75 8.8875 3.1125 11.25 6 11.25C8.8875 11.25 11.25 8.8875 11.25 6C11.25 3.1125 8.8875 0.75 6 0.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10070_2383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOfferInfo);
export default __webpack_public_path__ + "static/media/bank-offer-info.2dd793873315c9052cf9719df166f82d.svg";
export { ForwardRef as ReactComponent };